import '../../styles/about/about.css'; // Importing custom styles

const AboutSection = () => {
  return (
    <section className="about-section py-5">
      <div className="container py-4">
        <div className="row align-items-center">
          
          {/* Left Column: Image */}
          <div className="col-12 col-lg-6 mb-5 mb-lg-0">
            <div className="image-wrapper fade-in-left">
              <img 
                src="https://i.pinimg.com/736x/a3/20/06/a32006012771dbc63367b3fa248bba91.jpg" /* Replace with your actual image path */
                alt="Teacher in classroom" 
                className="img-fluid rounded shadow-sm w-100" 
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="col-12 col-lg-6 ps-lg-5">
            <div className="content-wrapper fade-in-right">
              
              {/* Pill Badge */}
              <div className="mb-3">
                <span className="badge-pill">ABOUT US</span>
              </div>

              {/* Heading */}
             <h2 className="display-5 fw-bold mb-4 text-dark">
  Your Success, <span className="text-purple mission-underline">Our Mission</span>
</h2>

              {/* Bold Italic Intro Paragraph */}
              <p className="lead fw-bold fst-italic text-secondary mb-4">
                Madhi Academy is Chennai's trusted hub for complete learning solutions — 
                guiding students from their early schooling years to global career opportunities. 
                Established over 12 years ago, we have built a reputation for academic excellence, 
                career-focused programs, and personalized mentorship.
              </p>

              {/* Regular Paragraph */}
              <p className="text-muted">
                Our approach combines structured teaching methods, experienced faculty, 
                and modern learning tools to ensure that every learner reaches their highest potential. 
                Whether you're a school student aiming for top grades, a graduate pursuing professional 
                qualifications, or a working professional seeking industry skills, Madhi Academy offers 
                a dedicated learning pathway for every goal.
              </p>

            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default AboutSection;